import { ReactNode, useMemo } from 'react';
import { useSelector } from 'storage';
import IPermissionService from 'services/permission/IPermissionService';

type PermissionGuardProps = {
  permission: IPermissionService.Permission;
  condition?: never;
  children: ReactNode;
};

type ConditionGuardProps = {
  permission?: never;
  condition: boolean;
  children: ReactNode;
};

export default function PermissionGuard(props: PermissionGuardProps | ConditionGuardProps) {
  const { permissions } = useSelector((state) => state.auth);
  const isPermissionAllowed = useMemo(() => (props.permission ? permissions.can(props.permission) : false), []);

  if (props.condition) return props.condition ? <>{props.children}</> : null;
  else if (props.permission) return isPermissionAllowed ? <>{props.children}</> : null;
  else return null;
}
